import React from 'react'
import CustomTabPanel from '../../istoric/components/TabPanel'
import GeneralDataContent from '../GeneralDataContent'
import InvoiceDataContent from '../InvoiceDataContent'
import EditGeneralDataModal from '../components/modals/EditGeneralDataModal'

const ProfileContent = ({
  tab,
  profileData,
  setIsGeneralModalOpen,
  achievements,
  setIsChangePasswordModalOpen,
  payments,
}) => {
  return (
    <>
      <CustomTabPanel
        value={tab}
        index={0}
        styles={{
          padding: '0 !important',
        }}
      >
        <GeneralDataContent
          setIsChangePasswordModalOpen={setIsChangePasswordModalOpen}
          achievements={achievements}
          setIsGeneralModalOpen={setIsGeneralModalOpen}
          profileData={profileData}
        />
      </CustomTabPanel>
      {tab === 1 ? (
        <CustomTabPanel value={tab} index={1}>
          <InvoiceDataContent payments={payments} />
        </CustomTabPanel>
      ) : null}
    </>
  )
}

export default ProfileContent
